import { render, staticRenderFns } from "./draftLetter.vue?vue&type=template&id=eebfb4e4&scoped=true"
import script from "./draftLetter.vue?vue&type=script&lang=js"
export * from "./draftLetter.vue?vue&type=script&lang=js"
import style0 from "./draftLetter.vue?vue&type=style&index=0&id=eebfb4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebfb4e4",
  null
  
)

export default component.exports